<div class="marv_section_title">
    @if(this.iconSection){
        <ion-icon [name]="this.iconSection"></ion-icon>        
    }
    {{this.titleSection}}
    <ng-content></ng-content>
</div>